var p = Object.defineProperty;
var g = (r, e, t) => e in r ? p(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var d = (r, e, t) => g(r, typeof e != "symbol" ? e + "" : e, t);
import { LOGGER as f, API as _ } from "@packages/common";
import { Injectable as y, Inject as l } from "@webmotors/ioc";
import { FAVORITES_SERVICE as v } from "./main38.js";
import { FavoriteVehicleTypeDTO as c } from "./main39.js";
var P = Object.defineProperty, E = Object.getOwnPropertyDescriptor, I = (r, e, t) => e in r ? P(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, m = (r, e, t, a) => {
  for (var o = a > 1 ? void 0 : a ? E(e, t) : e, s = r.length - 1, n; s >= 0; s--)
    (n = r[s]) && (o = n(o) || o);
  return o;
}, h = (r, e) => (t, a) => e(t, a, r), F = (r, e, t) => I(r, e + "", t);
let i = class {
  constructor(r, e) {
    d(this, "logger");
    this.apiService = e, this.logger = r.create(v);
  }
  getHeaders(r) {
    return {
      authorization: (r == null ? void 0 : r.authenticationToken) ?? ""
    };
  }
  fetchFavoritesPage(r, e, t) {
    return this.apiService.get(
      "/extras/showroom",
      {
        vehicle_type: e,
        actual_page: t,
        display_per_page: i.DISPLAY_PER_PAGE,
        sort: 1,
        site: !0
      },
      {
        headers: {
          ...this.getHeaders(r),
          "Cache-Control": "no-cache",
          Pragma: "no-cache"
        }
      }
    );
  }
  mapResult(r, e) {
    var t;
    return {
      advertiseId: r.advertise_id,
      guid: r.guid,
      site: !0,
      vehicleType: e,
      brand: r.brand,
      brandId: r.brandId,
      model: r.model,
      modelId: r.modelId,
      version: r.version,
      versionId: r.versionId,
      price: r.price,
      odometer: r.odometer,
      yearFabrication: r.year_fabrication,
      yearModel: r.year_model,
      primaryColor: r.primary_color,
      city: r.city,
      state: r.state,
      sellerType: r.seller_type,
      advertiser: r.advertiser,
      advertiserId: r.advertiserId,
      active: r.active,
      createDate: r.create_date,
      numberPorts: r.number_ports,
      listingType: r.listing_type,
      photos: (t = r.photos) != null && t.length ? r.photos : r.image_path ? [r.image_path] : []
    };
  }
  async fetchFavorites(r, e) {
    try {
      const t = await this.fetchFavoritesPage(r, e, 1);
      return { favorites: (t.results ?? []).map(
        (o) => this.mapResult(o, e)
      ), count: t.count };
    } catch (t) {
      return this.handleError(
        `[FetchFavorites] Error for type ${e}:`,
        t
      ), { favorites: [], count: 0 };
    }
  }
  /**
   * Fetch a single page of favorites for one vehicle type, including the
   * pagination metadata used to drive infinite scroll on the favorites screen.
   *
   * The favorites API is paginated and caps how many items it returns per
   * request, so the screen loads one page at a time as the user scrolls
   * instead of fetching everything up front (ENO-10086).
   *
   * @param user - The user's session
   * @param vehicleType - Car or bike
   * @param page - Page to fetch (1-based)
   * @returns A promise that resolves to a FavoritesPageDTO object
   */
  async getByType(r, e, t = 1) {
    if (!r)
      return { favorites: [], count: 0, page: t, totalPages: 0 };
    try {
      const a = await this.fetchFavoritesPage(r, e, t), o = a.count ?? 0, s = (a.results ?? []).map(
        (u) => this.mapResult(u, e)
      ), n = a.pages ?? (o > 0 ? Math.ceil(o / i.DISPLAY_PER_PAGE) : 0);
      return {
        favorites: s,
        count: o,
        page: a.actual_page ?? t,
        totalPages: n
      };
    } catch (a) {
      return this.handleError(
        `[GetByType] Error for type ${e} page ${t}:`,
        a
      ), { favorites: [], count: 0, page: t, totalPages: 0 };
    }
  }
  handleError(r, e) {
    const t = e.message;
    this.logger.error(r, t);
  }
  /**
   * Fetch all favorites for both cars and bikes for a given user.
   *
   * @param user - The user's session
   * @returns A promise that resolves to a FavoritesDTO object
   */
  async get(r) {
    if (!r)
      return this.logger.info("[Get] No JWT provided, returning empty favorites."), { favorites: [], count: 0 };
    try {
      const [e, t] = await Promise.all([
        this.fetchFavorites(r, c.CAR),
        this.fetchFavorites(r, c.BIKE)
      ]);
      return {
        favorites: [...e.favorites, ...t.favorites],
        count: e.count + t.count
      };
    } catch (e) {
      return this.handleError("[Get] Error fetching user favorites:", e), { favorites: [], count: 0 };
    }
  }
  /**
   * Add a favorite for a user.
   *
   * @param params - AddFavoriteDTO object containing user, id, and vehicleType
   * @returns A promise that resolves to a FavoriteItemDTO
   */
  async add({
    user: r,
    id: e,
    vehicleType: t
  }) {
    if (!r) return null;
    try {
      const a = t.includes("motos") ? c.BIKE : c.CAR, o = {
        advertise_id: Number(e),
        vehicle_type: a,
        site: !0
      }, s = await this.apiService.post("/extras/showroom", o, { headers: this.getHeaders(r) });
      return {
        advertiseId: s.id,
        guid: s.excludeFavoriteKey,
        site: !0,
        vehicleType: a
      };
    } catch (a) {
      return this.handleError("[Add] Error adding favorite:", a), null;
    }
  }
  /**
   * Remove a favorite for a user.
   *
   * @param params - RemoveFavoriteDTO object containing guid and user
   * @returns A promise that resolves to the removed favorite's guid
   */
  async remove({ guid: r, user: e }) {
    if (!e) return null;
    try {
      const t = { guid: r }, { guid: a } = await this.apiService.delete("/extras/showroom", t, { headers: this.getHeaders(e) });
      return a;
    } catch (t) {
      return this.handleError("[remove] Error removing favorite:", t), null;
    }
  }
};
F(i, "DISPLAY_PER_PAGE", 25);
i = m([
  y(v),
  h(0, l(f)),
  h(1, l(_))
], i);
export {
  i as FavoritesService
};
